import {dom, library} from '@fortawesome/fontawesome-svg-core';

// brand
import {faYoutube} from '@fortawesome/free-brands-svg-icons/faYoutube';

// solid
import {faAngleDoubleDown} from '@fortawesome/free-solid-svg-icons/faAngleDoubleDown';
import {faAngleLeft} from '@fortawesome/free-solid-svg-icons/faAngleLeft';
import {faAngleRight} from '@fortawesome/free-solid-svg-icons/faAngleRight';
import {faArrowLeft} from '@fortawesome/free-solid-svg-icons/faArrowLeft';
import {faArrowRight} from '@fortawesome/free-solid-svg-icons/faArrowRight';
import {faBug} from '@fortawesome/free-solid-svg-icons/faBug';
import {faCalendar} from '@fortawesome/free-solid-svg-icons/faCalendar';
import {faCalendarAlt} from '@fortawesome/free-solid-svg-icons/faCalendarAlt';
import {faCaretDown} from '@fortawesome/free-solid-svg-icons/faCaretDown';
import {faCaretUp} from '@fortawesome/free-solid-svg-icons/faCaretUp';
import {faChartLine} from '@fortawesome/free-solid-svg-icons/faChartLine';
import {faCheck} from '@fortawesome/free-solid-svg-icons/faCheck';
import {faChevronCircleDown} from '@fortawesome/free-solid-svg-icons/faChevronCircleDown';
import {faChevronCircleUp} from '@fortawesome/free-solid-svg-icons/faChevronCircleUp';
import {faChevronDown} from '@fortawesome/free-solid-svg-icons/faChevronDown';
import {faChevronRight} from '@fortawesome/free-solid-svg-icons/faChevronRight';
import {faCircle} from '@fortawesome/free-solid-svg-icons/faCircle';
import {faCircleNotch} from '@fortawesome/free-solid-svg-icons/faCircleNotch';
import {faClock} from '@fortawesome/free-solid-svg-icons/faClock';
import {faClone} from '@fortawesome/free-solid-svg-icons/faClone';
import {faCog} from '@fortawesome/free-solid-svg-icons/faCog';
import {faCopy} from '@fortawesome/free-solid-svg-icons/faCopy';
import {faDollarSign} from '@fortawesome/free-solid-svg-icons/faDollarSign';
import {faDownload} from '@fortawesome/free-solid-svg-icons/faDownload';
import {faEdit} from '@fortawesome/free-solid-svg-icons/faEdit';
import {faEllipsisV} from '@fortawesome/free-solid-svg-icons/faEllipsisV';
import {faExchangeAlt} from '@fortawesome/free-solid-svg-icons/faExchangeAlt';
import {faExclamationCircle} from '@fortawesome/free-solid-svg-icons/faExclamationCircle';
import {faExclamationTriangle} from '@fortawesome/free-solid-svg-icons/faExclamationTriangle';
import {faEye} from '@fortawesome/free-solid-svg-icons/faEye';
import {faFileInvoice} from '@fortawesome/free-solid-svg-icons/faFileInvoice';
import {faFolder} from '@fortawesome/free-solid-svg-icons/faFolder';
import {faGlobe} from '@fortawesome/free-solid-svg-icons/faGlobe';
import {faHistory} from '@fortawesome/free-solid-svg-icons/faHistory';
import {faInfoCircle} from '@fortawesome/free-solid-svg-icons/faInfoCircle';
import {faLayerGroup} from '@fortawesome/free-solid-svg-icons/faLayerGroup';
import {faListAlt} from '@fortawesome/free-solid-svg-icons/faListAlt';
import {faMap} from '@fortawesome/free-solid-svg-icons/faMap';
import {faMinus} from '@fortawesome/free-solid-svg-icons/faMinus';
import {faMobileAlt} from '@fortawesome/free-solid-svg-icons/faMobileAlt';
import {faObjectUngroup} from '@fortawesome/free-solid-svg-icons/faObjectUngroup';
import {faPencilAlt} from '@fortawesome/free-solid-svg-icons/faPencilAlt';
import {faPercentage} from '@fortawesome/free-solid-svg-icons/faPercentage';
import {faPlane} from '@fortawesome/free-solid-svg-icons/faPlane';
import {faPlus} from '@fortawesome/free-solid-svg-icons/faPlus';
import {faPollH} from '@fortawesome/free-solid-svg-icons/faPollH';
import {faQuestionCircle} from '@fortawesome/free-solid-svg-icons/faQuestionCircle';
import {faReceipt} from '@fortawesome/free-solid-svg-icons/faReceipt';
import {faRedo} from '@fortawesome/free-solid-svg-icons/faRedo';
import {faRetweet} from '@fortawesome/free-solid-svg-icons/faRetweet';
import {faSearch} from '@fortawesome/free-solid-svg-icons/faSearch';
import {faSignInAlt} from '@fortawesome/free-solid-svg-icons/faSignInAlt';
import {faSignOutAlt} from '@fortawesome/free-solid-svg-icons/faSignOutAlt';
import {faSort} from '@fortawesome/free-solid-svg-icons/faSort';
import {faSpinner} from '@fortawesome/free-solid-svg-icons/faSpinner';
import {faStamp} from '@fortawesome/free-solid-svg-icons/faStamp';
import {faStar} from '@fortawesome/free-solid-svg-icons/faStar';
import {faStreetView} from '@fortawesome/free-solid-svg-icons/faStreetView';
import {faSyncAlt} from '@fortawesome/free-solid-svg-icons/faSyncAlt';
import {faTable} from '@fortawesome/free-solid-svg-icons/faTable';
import {faTasks} from '@fortawesome/free-solid-svg-icons/faTasks';
import {faThumbsUp} from '@fortawesome/free-solid-svg-icons/faThumbsUp';
import {faTimes} from '@fortawesome/free-solid-svg-icons/faTimes';
import {faToggleOff} from '@fortawesome/free-solid-svg-icons/faToggleOff';
import {faToggleOn} from '@fortawesome/free-solid-svg-icons/faToggleOn';
import {faTrash} from '@fortawesome/free-solid-svg-icons/faTrash';
import {faTrashRestore} from '@fortawesome/free-solid-svg-icons/faTrashRestore';
import {faUndo} from '@fortawesome/free-solid-svg-icons/faUndo';
import {faUniversity} from '@fortawesome/free-solid-svg-icons/faUniversity';
import {faUserTag} from '@fortawesome/free-solid-svg-icons/faUserTag';
import {faUserTie} from '@fortawesome/free-solid-svg-icons/faUserTie';
import {faWallet} from '@fortawesome/free-solid-svg-icons/faWallet';

// regular
import {faCheckSquare as farCheckSquare} from '@fortawesome/free-regular-svg-icons/faCheckSquare';
import {faEnvelope} from '@fortawesome/free-regular-svg-icons/faEnvelope';
import {faFilePdf} from '@fortawesome/free-regular-svg-icons/faFilePdf';
import {faFileWord} from '@fortawesome/free-regular-svg-icons/faFileWord';
import {faSquare as farSquare} from '@fortawesome/free-regular-svg-icons/faSquare';
import {faStar as farStar} from '@fortawesome/free-regular-svg-icons/faStar';

library.add(
    // brand
    faYoutube,

    // solid
    faAngleDoubleDown,
    faAngleLeft,
    faAngleRight,
    faArrowLeft,
    faArrowRight,
    faBug,
    faCalendar,
    faCalendarAlt,
    faCaretDown,
    faCaretUp,
    faClock,
    faChartLine,
    faCheck,
    faCircle,
    faCircleNotch,
    faClone,
    faCog,
    faCopy,
    faChevronCircleDown,
    faChevronCircleUp,
    faChevronDown,
    faChevronRight,
    faDollarSign,
    faDownload,
    faEdit,
    faEllipsisV,
    faExchangeAlt,
    faExclamationCircle,
    faEye,
    faExclamationTriangle,
    faFileInvoice,
    faFolder,
    faHistory,
    faInfoCircle,
    faGlobe,
    faLayerGroup,
    faListAlt,
    faMap,
    faMinus,
    faMobileAlt,
    faObjectUngroup,
    faPencilAlt,
    faPercentage,
    faPlane,
    faPlus,
    faPollH,
    faQuestionCircle,
    faReceipt,
    faRedo,
    faRetweet,
    faSearch,
    faSignInAlt,
    faSignOutAlt,
    faSort,
    faSpinner,
    faStamp,
    faStar,
    faStreetView,
    faSyncAlt,
    faTable,
    faTasks,
    faThumbsUp,
    faTimes,
    faToggleOff,
    faToggleOn,
    faTrash,
    faTrashRestore,
    faUndo,
    faUniversity,
    faUserTag,
    faUserTie,
    faWallet,

    // regular
    faEnvelope,
    faFilePdf,
    faFileWord,
    farCheckSquare,
    farSquare,
    farStar,
);
dom.watch();
